import React, { useState } from "react";
import styles from "./AnnouncementBar.module.css";
import { useTranslation } from 'react-i18next';

const AnnouncementBar = ({ announcement }) => {
  const [visible, setVisible] = useState(true);
  const { t } = useTranslation('announcementBar');

  const hasTitle = typeof announcement?.title === 'string' && announcement.title.trim() !== '';
  const hasBody = typeof announcement?.body === 'string' && announcement.body.trim() !== '';

  if ((!hasTitle && !hasBody) || !visible) return null;

  return (
    <div className={styles.announcementBar}>
      <span className={styles.icon} aria-label={t('ariaLabel')}>
        <img src="/icons/Megaphone2.svg" alt={t('alt')} style={{width: '1.2em', verticalAlign: 'middle'}} />
      </span>
      <div className={styles.textWrap}>
        {hasTitle && <strong className={styles.title}>{announcement.title}</strong>}
        {hasBody && <span className={styles.body}>{announcement.body}</span>}
      </div>
      <button className={styles.closeBtn} onClick={() => setVisible(false)} aria-label={t('closeAriaLabel')}>×</button>
    </div>
  );
};

export default AnnouncementBar;
